import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";

function HomeAddresses({ application }) {
  const [isOpen, setIsOpen] = useState(false);

  let bintiAddresses = [];

  //If there is Binti Application, pull in the Address Objects from only the first Binti Application. Other Binti apps are previous instances
  if (application.HomeData && application.HomeData.length > 0) {
    application.HomeData[0].addresses.forEach((a) =>
      bintiAddresses.push({
        streetaddress: a.streetaddress,
        city: a.city,
        state: a.state,
        postalcode: a.postalcode,
        telephone1: a.telephone1,
        telephone2: a.telephone2,
        type: a.type,
        createdon: a.createdon,
        updatedon: a.updatedon,
        effective: a.effective,
        expiration: a.expiration,
        source: "BINTI",
      })
    );
  }

  let soarAddresses = [];
  // if (application.SoarData && application.SoarData.length > 0) {
  //   application.SoarData.forEach((hd) => {
  //     hd.addresses.forEach((a) =>
  //       soarAddresses.push({
  //         streetaddress: a.streetaddress,
  //         city: a.city,
  //         state: a.state,
  //         postalcode: a.postalcode,
  //         telephone1: a.telephone1,
  //         telephone2: a.telephone2,
  //         type: a.type,
  //         createdon: a.createdon,
  //         updatedon: a.updatedon,
  //         effective: a.effective,
  //         expiration: a.expiration,
  //         source: "SOAR",
  //       })
  //     );
  //   });
  // }

  //   const bintiAddresses = addresses.filter((m) => m.source === "BINTI");
  //   const soarAddresses = addresses.filter((m) => m.source === "SOAR");

  return (
    <>
      <Modal show={isOpen} animation={false} onHide={() => setIsOpen(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Addresses</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {bintiAddresses && bintiAddresses.length > 0
            ? bintiAddresses.map((a, index) => {
                return a.streetaddress !== null ? (
                  <div
                    className="border border-dark rounded bg-light p-2 mb-2 ps-4"
                    key={`ba${application.id}${index}`}
                  >
                    <div className="row fw-bold">
                      {`${a.source} ${a.type}`}
                      <i
                        className="fa fa-map-pin text-danger ms-2"
                        onClick={() =>
                          window.open(
                            `https://maps.google.com/?q=${a.streetaddress} ${a.city} ${a.state} ${a.postalcode}`
                          )
                        }
                      ></i>
                    </div>
                    <div className="row">
                      <div className="col">{a.streetaddress}</div>
                    </div>
                    <div className="row mb-4">
                      <div className="col">
                        {`${a.city} ${a.state} ${a.postalcode}`}
                      </div>
                    </div>
                    <div className="row">
                      <div className="col">Telephone</div>
                      <div className="col">{a.telephone1}</div>
                    </div>
                    {a.telephone1 ? (
                      <div className="row">
                        <div className="col">Telephone 2</div>
                        <div className="col">{a.telephone2}</div>
                      </div>
                    ) : null}
                    {a.effective ? (
                      <div className="row">
                        <div className="col">effective</div>
                        <div className="col">{a.effective}</div>
                      </div>
                    ) : null}
                    {a.expiration ? (
                      <div className="row">
                        <div className="col">expiration</div>
                        <div className="col">{a.expiration}</div>
                      </div>
                    ) : null}
                  </div>
                ) : null;
              })
            : null}
          {soarAddresses &&
            soarAddresses.length > 0 &&
            soarAddresses.map((a, index) => {
              return a.streetaddress !== null ? (
                <div
                  className="border border-dark rounded bg-light p-2 mb-2 ps-4"
                  key={`sa${application.id}${index}`}
                >
                  <div className="row fw-bold">
                    {`${a.source} ${a.type}`}
                    <i
                      className="fa fa-map-pin text-danger ms-2"
                      onClick={() =>
                        window.open(
                          `https://maps.google.com/?q=${a.streetaddress} ${a.city} ${a.state} ${a.postalcode}`
                        )
                      }
                    ></i>
                  </div>
                  <div className="row">
                    <div className="col">{a.streetaddress}</div>
                  </div>
                  <div className="row mb-4">
                    <div className="col">
                      {`${a.city} ${a.state} ${a.postalcode}`}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col">Telephone</div>
                    <div className="col">{a.telephone1}</div>
                  </div>
                  {a.telephone1 ? (
                    <div className="row">
                      <div className="col">Telephone 2</div>
                      <div className="col">{a.telephone2}</div>
                    </div>
                  ) : null}
                  {a.effective ? (
                    <div className="row">
                      <div className="col">effective</div>
                      <div className="col">{a.effective}</div>
                    </div>
                  ) : null}
                  {a.expiration ? (
                    <div className="row">
                      <div className="col">expiration</div>
                      <div className="col">{a.expiration}</div>
                    </div>
                  ) : null}
                </div>
              ) : null;
            })}
        </Modal.Body>
      </Modal>
      {(soarAddresses.length > 0 &&
        soarAddresses.filter((a) => a.streetaddress !== null).length > 0) ||
      (bintiAddresses.length > 0 &&
        bintiAddresses.filter((a) => a.streetaddress !== null).length > 0) ? (
        <i
          className="fa fa-map-pin fa-lg"
          role="button"
          title="Addresses"
          onClick={() => setIsOpen(!isOpen)}
        ></i>
      ) : null}
    </>
  );
}

export default HomeAddresses;
